module.exports = __webpack_public_path__ + "img/bg_7.a1ba3567.jpg";